const MIN_WIDTH_BREAKPOINT = '(min-width: 1023px)';
const MAX_WIDTH_BREAKPOINT = '(max-width: 1022px)';

export {
    MIN_WIDTH_BREAKPOINT,
    MAX_WIDTH_BREAKPOINT,
};
